"use client"
import merge from "deepmerge"
import { SessionProvider } from "next-auth/react"
import PropTypes from "prop-types"
import { ThemeProvider } from "styled-components"

import { theme as tsrTheme } from "@/design/tsr-ui/components"
import { LocaleConfigProvider } from "@/providers"
import { theme as appTheme } from "@/theme"

const theme = merge(tsrTheme, appTheme)

export function Providers({ children, config }) {
  return (
    <LocaleConfigProvider value={config.localeConfig}>
      <SessionProvider>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </SessionProvider>
    </LocaleConfigProvider>
  )
}

Providers.propTypes = {
  config: PropTypes.object.isRequired,
}
